const { handleError, handleResponse, api } = require("./baseApi");

const api_config = require("./api_config");


function getBasketsApi(codes = [], includePublic = '') {
    const queryString = codes ? ('?codes=' + codes.join('&codes=') + (includePublic ? '&includePublic=' + includePublic : '')) : '';

    return api
        .get(
            `projects/v1/baskets${queryString}`,
            {
                headers: {
                    "x-api-key": `${api_config.carbon_app_api_key}`
                }
            }
        )
        .then(handleResponse)
        .catch(handleError);
}

function getBasketByIdApi(id) {
    return api
        .get(
            `projects/v1/baskets/${id}`,
            {
                headers: {
                    "x-api-key": `${api_config.carbon_app_api_key}`
                }
            }
        )
        .then(handleResponse)
        .catch(handleError);
}

function getProjectsApi(countryCode, merchantCode, locale) {
    let queryArray = [];
    if (locale) queryArray.push("locale=" + locale);
    if (countryCode) queryArray.push("countryCode="+countryCode);
    if (merchantCode) queryArray.push("merchantCode="+merchantCode);
    let queryString = queryArray.length ? '?'+queryArray.join("&") : "";
    return api
        .get(
            `projects/v1/${queryString}`,
            {
                headers: {
                    "x-api-key": `${api_config.carbon_app_api_key}`
                }
            }
        )
        .then(handleResponse)
        .catch(handleError);
}

function getProjectByCodeApi(code){
    return api.get(
        `projects/v2/${code}`,
        {
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            }
        }
    )
    .then(handleResponse)
    .catch(handleError);
}

function getProjectByMerchantCodeApi(merchantCode) {
    return api.get(
        `projects/v1?merchantCode=${merchantCode}`,
        {
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            }
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

function getProjectInventoryApi(projectId) {
    return api.get(
        `/projects/v1/${projectId}/inventories`,
        {headers: {"x-api-key": `${api_config.carbon_app_api_key}`}}
    )
    .then(handleResponse)
    .catch(handleError)
}

function getInventorySalesByProjectApi(projectId, locale, purchasedDateAfter, purchasedDateBefore, size) {
    let queryArray = [];
    if (locale) queryArray.push("locale=" + locale);
    if(purchasedDateAfter) queryArray.push("purchaseCreatedAt=gt:" + purchasedDateAfter);
    if(purchasedDateBefore) queryArray.push("purchaseCreatedAt=lt:" + purchasedDateBefore);
    if(size) queryArray.push("size=" + size);

    let queryString = queryArray.length ? '?'+queryArray.join("&") : "";

    return api.get(
        `/projects/v1/${projectId}/sales${queryString}`,
        {headers: {"x-api-key": `${api_config.carbon_app_api_key}`}}
    )
    .then(handleResponse)
    .catch(handleError)
}

module.exports = { getProjectsApi, getProjectByCodeApi, getProjectInventoryApi, getInventorySalesByProjectApi, getBasketsApi, getBasketByIdApi, getProjectByMerchantCodeApi};
